/** Tipo de funil armazenado em `leads.crm_funil` / query da API. */
export const CRM_FUNIL_VENDAS = 'vendas' as const;
export const CRM_FUNIL_PARCERIA_PROSPECCAO = 'parceiro_prospeccao' as const;

export type CrmFunilTipo = typeof CRM_FUNIL_VENDAS | typeof CRM_FUNIL_PARCERIA_PROSPECCAO;

export const PRODUTO_LEAD_PARCERIA_CRM = 'Prospecção Parceiro Sun7' as const;
